export const META_TYPE = 'batteryOverview';
export const META_VER = 'v1';

export const CMD_BATTERY_OVERVIEW_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
